import { render, staticRenderFns } from "./DeSelectTree.vue?vue&type=template&id=1483f2a2&"
import script from "./DeSelectTree.vue?vue&type=script&lang=js&"
export * from "./DeSelectTree.vue?vue&type=script&lang=js&"
import style0 from "./DeSelectTree.vue?vue&type=style&index=0&id=1483f2a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports